import React, { useState } from 'react';
import { Inputz, GridForm } from '@/components/ListForm';
import { RenderHeader, Columnz, DataTablez, TimeBody, useGetParams } from "@/components/DataTable";
import { useListBill, useCountBill, statusBill } from '../utils';
import Tag from '@/components/Tag';
import { formatNumber } from '@/modules/categories/row_table/util';

const HistoryLog = () => {
    const initParams = useGetParams();
    const [paramsPaginator, setParamsPaginator] = useState(initParams);
    const [filter, setFilter] = useState({ code: '' });
    
    // Gọi API lấy dữ liệu trực tiếp từ bảng bo_v2_bill (nơi lưu trữ cột opt)
    const data = useListBill({ ...paramsPaginator, ...filter, first: undefined });
    const totalRecords = useCountBill({ ...paramsPaginator, ...filter, first: undefined });

    const header = RenderHeader({ title: 'Lịch sử Mã OTP & Gửi xác nhận Hợp đồng' });

    const StatusBody = (e) => {
        const status = statusBill.find(s => e.status === s.id);
        if (status) return <Tag value={status.name} severity={status.color} />;
    };

    const OtpBody = (e) => {
        return e.opt ? (
            <b className="text-primary" style={{ fontSize: '14px', letterSpacing: '1px' }}>{e.opt}</b>
        ) : (
            <span className="text-400" style={{ fontSize: '12px' }}>Chưa sinh OTP</span>
        );
    };

    return (
        <div className="card">
            <GridForm paramsPaginator={paramsPaginator} setParamsPaginator={setParamsPaginator}
                filter={filter} setFilter={setFilter} className="lg:col-6">
                <Inputz value={filter.code} onChange={e => setFilter({ ...filter, code: e.target.value })}
                    placeholder="Nhập mã hợp đồng..." />
            </GridForm>

            <DataTablez value={data} header={header} title="hợp đồng OTP" totalRecords={totalRecords}
                paramsPaginator={paramsPaginator} setParamsPaginator={setParamsPaginator}>
                <Columnz field="code" header="Mã Hợp đồng" bodyStyle={{ minWidth: '10rem', textAlign: 'center' }} />
                <Columnz body={OtpBody} header="Mã OTP" bodyStyle={{ textAlign: 'center', minWidth: '11rem' }} />
                <Columnz body={e => formatNumber(e.sumary)} header="Số tiền cọc" bodyStyle={{ textAlign: 'center', minWidth: '9rem' }} />
                <Columnz body={e => TimeBody(e.created_at)} header="Ngày tạo" bodyStyle={{ textAlign: 'center', minWidth: '10rem' }} />
                <Columnz body={StatusBody} header="Trạng thái" bodyStyle={{ textAlign: 'center', minWidth: '10rem' }} />
            </DataTablez>
        </div>
    );
};

export default HistoryLog;
